var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 31,
    viewBox: "0 0 19 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1871 15.5L1.26635 3.95322C0.827673 3.51327 0.584936 2.92403 0.590423 2.31241C0.59591 1.70079 0.849182 1.11572 1.29569 0.683227C1.74219 0.250729 2.34621 0.00540301 2.97764 8.81815e-05C3.60907 -0.00522665 4.2174 0.229895 4.6716 0.654812L18.295 13.8508C18.7465 14.2882 19.0001 14.8815 19.0001 15.5C19.0001 16.1185 18.7465 16.7118 18.295 17.1492L4.6716 30.3452C4.2174 30.7701 3.60907 31.0052 2.97764 30.9999C2.34621 30.9946 1.74219 30.7493 1.29569 30.3168C0.849182 29.8843 0.59591 29.2992 0.590423 28.6876C0.584936 28.076 0.827673 27.4867 1.26635 27.0468L13.1871 15.5Z",
    fill: "#8F8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.689fb2b272af6969e6b37e5ebeb31f65.svg";
export { ForwardRef as ReactComponent };